import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import CurrencyList from './list/list';

const CurrencyListModule = () => {
  return (
    <PageContentWrapper>
      <Routes>
        <Route path="/" element={<CurrencyList />} />
      </Routes>
    </PageContentWrapper>
  );
};

export default CurrencyListModule;
